import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState, useEffect } from "react";
function Article2() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const { ref: thirdContainer, inView: thirdInView } = useInView({
    threshold: 0
  });

  const { ref: fourContainer, inView: fourInView } = useInView({
    threshold: 0
  });

  const { ref: fiveContainer, inView: fiveInView } = useInView({
    threshold: 0
  });

  const { ref: sixContainer, inView: sixInView } = useInView({
    threshold: 0
  });

  const { ref: sevenContainer, inView: sevenInView } = useInView({
    threshold: 0
  });

  const { ref: eightContainer, inView: eightInView } = useInView({
    threshold: 0
  });

  const { ref: nineContainer, inView: nineInView } = useInView({
    threshold: 0
  });

  const { ref: tenContainer, inView: tenInView } = useInView({
    threshold: 0
  });

  const { ref: elevenContainer, inView: elevenInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (thirdInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = 'active';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (fourInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = 'active';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (fiveInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = 'active';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (sixInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = 'active';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (sevenInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = 'active';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (eightInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = 'active';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (nineInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = 'active';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (tenInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = 'active';
      var img3 = document.getElementById("img11");
      img3.className = '';

      return "";
    }
    else if (elevenInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = '';
      var img3 = document.getElementById("img3");
      img3.className = '';
      var img3 = document.getElementById("img4");
      img3.className = '';
      var img3 = document.getElementById("img5");
      img3.className = '';
      var img3 = document.getElementById("img6");
      img3.className = '';
      var img3 = document.getElementById("img7");
      img3.className = '';
      var img3 = document.getElementById("img8");
      img3.className = '';
      var img3 = document.getElementById("img9");
      img3.className = '';
      var img3 = document.getElementById("img10");
      img3.className = '';
      var img3 = document.getElementById("img11");
      img3.className = 'active';

      return "";
    }

  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article3');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article1');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/2-WHISKY-DISTILLERIES.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article2-left-img1.jpg")} />
          <img id="img3" className={getAnimationClass()} src={require("../../Images/article2-left-img2.jpg")} />
          <img id="img4" className={getAnimationClass()} src={require("../../Images/article2-left-img3.jpg")} />
          <img id="img5" className={getAnimationClass()} src={require("../../Images/article2-left-img4.jpg")} />
          <img id="img6" className={getAnimationClass()} src={require("../../Images/article2-left-img5.jpg")} />
          <img id="img7" className={getAnimationClass()} src={require("../../Images/article2-left-img6.jpg")} />
          <img id="img8" className={getAnimationClass()} src={require("../../Images/article2-left-img7.jpg")} />
          <img id="img9" className={getAnimationClass()} src={require("../../Images/article2-left-img8.jpg")} />
          <img id="img10" className={getAnimationClass()} src={require("../../Images/article2-left-img9.jpg")} />
          <img id="img11" className={getAnimationClass()} src={require("../../Images/article2-left-img10.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/2-WHISKY-DISTILLERIES.jpg")} alt="" />
          </motion.div>
          <motion.div
            variants={textAnimate}
            className="hamburger-menu">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="mb-4 mb-sm-5" ref={firstContainer}>
              <div
                variants={textAnimate}
              >
                <h1 className="fs-xxl mt-0 pt-2 mb-4 f-lora">Whisky <br />Distilleries</h1>
                <h3 className="mt-0 mb-4 mb-sm-5 pb-2 f-lora-i">A roundup of some of Scotland's best whisky distillery experiences.</h3>
              </div>

              <p className="" variants={textAnimate}>Malted barley, water and yeast. Three simple ingredients that unlock a world of stories, memories, aromas, seasons and flavours. Malt whisky isn't so much a product of Scotland as a part of it - a heady distillation of the country's soul and soil. More than 140 malt and grain distilleries are dotted around the national map, collectively forming the world's greatest concentration of whisky producers. Each one, in its own way, conjures magic in a glass.</p>
              <p className="" variants={textAnimate}>Some are old, seemingly as much a part of the landscape as the machair grass and ancient pine forests. Others are more modern, bringing fresh ideas and new ways of doing things.</p>
              <p className="" variants={textAnimate}>All have tales worth telling. The tastes and scents evoked by Scotland's single malts famously vary from region to region - more often than not, they also vary from distillery to distillery.  In this feature we focus on ten of the most interesting producers in the country. All reflect something of Scotland's long history and rich terroir, and all have the power to transport you with something simple yet complex: a drop of cask-matured amber liquid. So pull up a chair, settle by the fireside and pour yourself a dram. This is the good stuff.</p>
              
            </div>

            <div className="" ref={secondContainer}>
              <img
                src={require("../../Images/article2-right-img1.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              
              <img
                src={require("../../Images/article2-right-img2.jpg")}
                className={"w-100 mb-4 mb-sm-5"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">JURA DISTILLERY</h2>
                    <h4 className="f-lora-i">Isle of Jura</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-2 mt-sm-5 pt-2" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular" variants={textAnimate}>A trip to Jura generally requires getting to Islay first. Sail from Kennacraig on the mainland to Port Askaig on Islay, then catch the small car ferry from Port Askaig to Feolin on Jura - a crossing of less than 10 minutes.</h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>Welcome to a place apart. A grand total of around 212 people live on the wild Inner Hebridean island of Jura, where they're outnumbered about 30 to one by red deer. The island has one proper road - a snaking stretch of singletrack - three conical quartzite mountains known as the Paps of Jura, and one whisky distillery. Some 80 years ago, George Orwell decamped to a farmhouse here to write his classic dystopian novel 1984, and the island is as singular today as it was then.</p>
                  <p className=" text-justify" variants={textAnimate}>It brings a uniquely rare feel to the island's whisky. There's been a licensed distillery here since way back in 1810 - in Craighouse, Jura's largest village - and pleasingly, today's operation occupies the same site. It's been there since 1963 in its current form, making this year its 60th anniversary. Just as appealing for connoisseurs is the fact that Jura sits a mere ten-minute ferry hop from the hallowed whisky island of Islay, which tells you something of the tastes and terroir you can expect.</p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>Given the size of the island's population, a sense of community still underpins everything the distillery produces. The two local landowners who got things up and running in the 1960s did so partly as a way of bringing more jobs to an island that needed a fresh lease of life. Happily, the whisky that comes from the stillhouse's four colossal lanternshaped stills is rejuvenating in its own right, with a sweet, fruity nose and a smoky finish.</p>
                  <p className=" text-justify" variants={textAnimate}>The core range has four different bottlings: a 10 year old, a 16 year old, the heavily peated Prophecy and the smoky Superstition. A valuable rarity is the 1984 bottling, created to commemorate George Orwell's links to the island. Big Brother is watching you - and probably fancies a dram himself</p>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    Choose from the daily tours, which include tastings of two drams, or the 'Exclusives Tour', which allows you to sample older casks.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Deer Island Rum Distillery</span>
                    A couple of minutes away from the whisky distillery is this small-batch spiced rum producer, with a shop on site.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Whisky Island Gallery & Studio</span>
                    Also nearby is the studio of award-winning photographer Konrad Borkowski, who has been living on the island for almost two decades.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">The Antlers</span>
                    A popular spot in Craighouse serving daily specials, hot drinks and sweet treats - ice cream is the speciality
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Jura Hotel</span>
                    Just metres from the distillery, the hotel looks out across the water and has a good menu of starters and mains, including Steak & Ale Slab Pie.
                  </p>
                </div>
              </div>
              
            </div>

            <div className="mt-5" ref={thirdContainer}>
              <img
                src={require("../../Images/article2-right-img3.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5 pb-4">
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img4.jpg")}
                  />
                </div>
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img5.jpg")}
                  />
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">CAOL ILA</h2>
                    <h4 className="f-lora-i">Isle of Islay</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>Sail from Kennacraig on the mainland to Port Askaig on Islay. The distillery is 1.5 miles north by road from the ferry terminal.</h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>The Sound of Islay is the narrow stretch of sea that flows between the islands of Islay and Jura. In the Gaelic tongue it translates as Caol Ila, an apt - and softly lyrical - name for the distillery that overlooks the water.  Built back in 1846 by far-sighted Glasgow businessman Hector Henderson, whose workers practically hewed it out of the rocks, the site has since been fully expanded and modernised. It now stands on the water's edge in the manner classic to Islay, with its name spelled out in giant black letters on salty-aired, whitewashed walls.</p>

                  <p variants={textAnimate}>For much of the distillery's existence, its smoky whisky was used solely for blending - a dedicated pier was built in 1879 to allow mainland puffers to bring supplies and carry whisky back to the thirsty masses - but since 1989, when the first Caol Ila single malt was released, its reputation has grown in kind.  By the late 1990s it was also releasing an annual unpeated spirit, and additional variant introductions </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>have included the crisp, bright Moch and a number of special releases. The 12-year-old single malt, however, remains the entry-level whisky, and is now an Islay classic: sweet, fragrant and smooth, with subtle traces of citrus.</p>
                  <p className=" text-justify" variants={textAnimate}>A 20th-century takeover by drinks giant Diageo means Caol Ila is branded as one of the Four Corners distilleries of Johnnie Walker - the others being Glenkinchie in the Lowlands, Cardhu in Speyside and Clynelish in the Highlands. For whisky tourists, this brings the advantage of an amped-up visitor experience, with a bar giving sweeping views of the Paps of Jura across the water. The still house - where six, onion-shaped wash stills work their magic - shares the same, mighty panorama. </p>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    Caol Ila's signature tour is the Flavour Journey, with a tasting in the scenic bar. The other option is the Spirit of Smoke tour, which samples five cask-strength whiskies.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Other distilleries</span>
                    Islay is famed worldwide for its single malts - this is your chance to call in at the likes of Laphroaig, Bowmore, Ardbeg and Lagavulin.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Museum of Islay Life</span>
                    An absorbing local museum based in Port Charlotte, packed with photographs, stories and all manner of historical objects.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Old Kiln Café</span>
                    A small but good quality dining spot at Ardbeg, serving seafood dishes, comfort food and plenty more. 
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Peatzeria</span>
                    A very popular pizza joint on the seafront in Bowmore. Extra plaudits for the pun in the name.
                  </p>
                </div>
              </div>
              
            </div>

            <div className="" ref={fourContainer}>
              <img
                src={require("../../Images/article2-right-img6.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5 pb-4">
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img7.jpg")}
                  />
                </div>
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img8.jpg")}
                  />
                </div>
              </div>
              <div className="row mb-4 mb-sm-5 pt-0 pt-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">GLENKINCHIE</h2>
                    <h4 className="f-lora-i">Lothian</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>Pre-bookable daily shuttle buses depart from Edinburgh's Waterloo Place to the distillery. The journey time is around 30 minutes. </h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>Who says cities can't get in on the act? Sitting only around 12 miles from Edinburgh's Old Town, yet somehow feeling entirely removed from the hubbub of the capital, Glenkinchie is a tradition-rich Lowland distillery, surrounded by barley fields and sitting on the banks of the Kinchie burn. It was established under its existing name back in the 1830s and - with the exception of a short period as a sawmill, and the enforced pause of the two world wars - has been in production ever since.</p>
                  <p className=" text-justify" variants={textAnimate}>This tells you plenty about the quality of its fine, pale, dry whisky. In 1885, a moneyed enthusiast named Alfred Barnard took it upon himself to visit every distillery in Britain with a group of friends. Of Glenkinchie, he wrote: “How delighted we were to leave the City behind us and make for the country, there to inhale the restoring balms with which countless blossoms were loading the soft and </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>vernal gale! The proprietors… yield to none in the quality of the barley used in the production of their fine spirit. It possesses a flavour that is seldom to be met with in this region.” His enthusiasm is still mirrored by many today.</p>
                  <p className=" text-justify" variants={textAnimate}>Those early days are still held dear. Even today, one local family has had continuous links with Glenkinchie since the 1920s, with multiple generations of the Christie family having worked in the distillery over the entirety of the past century. And few drinkers would deny that the product is still one to take pride in - lowland whiskies tend to have grassier, more floral notes than their counterparts elsewhere in Scotland, something you can sample for yourself on a day-trip from Edinburgh. Or, indeed, by just wandering into a dedicated whisky bar. It's great as an aperitif. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    There are three different tours to choose from, the pick of which is the Hidden Lowland Tour & Tasting, which visits littleseen parts of the distillery.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">National Museum of Flight</span>
                    Explore Scotland's aviation history, interactive galleries, Concorde, hands-on activities, wartime stories, cafe, shop and outdoor picnic area. 
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Pencaitland Parish Church</span>
                    An atmospheric example of an early Scottish Parish Kirk, with fascinating carvings. It was consecrated in 1242.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">The Winton</span>
                    An excellent village restaurant specialising in local produce sourced from Scottish suppliers.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Rosearista Coffee Shop</span>
                    A family-run coffee shop on the outskirts of Pencaitland, just a few miles from the distillery, with fresh scones daily.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-2 mt-sm-5 pt-2" ref={fiveContainer}>
              <img
                src={require("../../Images/article2-right-img9.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">SPRINGBANK DISTILLERY</h2>
                    <h4 className="f-lora-i">Campbeltown</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>CalMac usually runs a seasonal summer ferry service from Ardrossan, west of Glasgow, to Campbeltown. Otherwise your options are car, bus or bike.</h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>There's more to Campbeltown than meets the eye. The coastal settlement is spread across the banks of a sea loch on the Kintyre Peninsula and is home to less than 5,000 people, but was at one point known as the whisky capital of the world. At its peak, as many as 30 distilleries were in business. Even today - despite its size - Campbeltown remains one of five protected localities in the country. But the number of producers has dropped dramatically over the years, with arguably only the best remaining. Just three are still standing, the pick of which is the inimitable Springbank, the oldest independent family-owned distillery in Scotland. </p>
                  <p className=" text-justify" variants={textAnimate}>The name enjoys cult status among connoisseurs, principally due to the quality of its traditional style of whisky. What's more, 100 percent of the whisky production process is completed on site, from malting and maturation through to bottling.  </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>Methods such as floor-malting are still in use here, and the whole feel of the place still gives a sense of treading back in time. It was formally founded way back in the 1820s - although legend has it that illegal distillation was taking place on the same site far earlier - and is now approaching its 200th anniversary.</p>
                  <p className=" text-justify" variants={textAnimate}>There are three distinct single malts in the core range: the unpeated Hazelburn (dried using only hot air), the lightly peated Springbank and the more heavily peated Longrow. It also produces limited edition whiskies, again using locally grown barley. All the distillery's bottlings are matured for between 10 and 25 years, and generally have hefty price tags. And while they may be expensive, their deft complexity means they're popular for very good reason.</p>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    Opt for the basic tour, or splash out on the 4-5 hour Barley to Bottle Tour, which gives hands-on, access-all-areas insight.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Davaar Island</span>
                    Head out to this tidal island, reachable via a natural shingle causeway when the tide's out. Be sure to check tide timings first.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Glen Scotia Distillery</span>
                    Another Campbeltown whisky producer with a sterling reputation, offering tours, tastings and more.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">The Black Sheep Pub</span>
                    A lively spot in Campbeltown's Royal Hotel, named Southwest Pub of the Year a few years ago in the Scottish Bar & Brew Awards. 
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Number Forty Two</span>
                    An elegant fine-dining spot, guided by the hand of chef Gordon McNeill, with a daily changing menu of fresh items.
                  </p>
                </div>
              </div>
            </div>

            <div className="" ref={sixContainer}>
              <img
                src={require("../../Images/article2-right-img10.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <img
                src={require("../../Images/article2-right-img11.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />

              <div className="row mb-4 mb-sm-5 pt-0 pt-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">ANNANDALE DISTILLERY</h2>
                    <h4 className="f-lora-i">Dumfries & Galloway</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3 pt-2" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>The distillery's location just a few miles from the border makes it an easy trip from northwest England, being just 35 minutes from Carlisle. </h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>George Donald knew what he was about. In 1836, the former excise officer from Aberdeenshire found a forest clearing near the English border that ticked all the right boxes for a distillery. It had a nearby water source, a ready supply of peat and a damp, mild climate. So was born the Annandale Distillery, which operated successfully until 1918, when a mixture of war and prohibition stopped it in its tracks. A whiskyless silence then reigned for almost a century, until in 2014 Professor David Thomson and Teresa Church reopened the distillery, looking to revive its heritage and produce quality single malts. It's fair to say it's not looked back.</p>
                  <p className=" text-justify" variants={textAnimate}>Today, its twin copper stills allow for production of both peated and unpeated new-make spirit. After being filled into casks and matured in a 300-year-old bonded warehouse, this evolves into a drink of remarkable quality and smoothness. The first cask of its peated 'Cask 40' was filled </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>by late rugby great Doddie Weir - the distillery ultimately raised almost £28,000 for Doddie's motor neurone disease foundation - and bottles of some rare vintages can now fetch upwards of £3,000. </p>
                  <p className=" text-justify" variants={textAnimate}>Another personality with strong associations with the business was Dr Jim Swan, a legendary expert on single malt. He passed away in 2017, but had been instrumental in helping Annandale make its name. Today its best known single-cask whiskies are the unpeated Man O'Words, named in honour of poet Robert Burns, and the peated Man O'Sword, named after Robert The Bruce. Fittingly, the latter once had a motte and bailey castle close to the site of the distillery </p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    The classic tour of Annandale Distillery lasts around an hour, including five tastings and various promotional goodies.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Gretna Green</span>
                    A 15-minute drive brings you to Gretna Green, where the Famous Blacksmith's Shop - now more of a visitor complex - is the main draw.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Annan Museum</span>
                    Housing a permanent collection that covers the history of Annan and the surrounding area.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">The Maltings Coffee Shop</span>
                    The distillery is home to the Dumfries & Galloway Cafe of the Year, serving soups, sandwiches and afternoon teas.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">The Shed</span>
                    Sports-mad pub in Annan, with awards to its name and a wide range of drinks.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-2 mt-sm-5 pt-2" ref={sevenContainer}>
              <img
                src={require("../../Images/article2-right-img12.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <img
                src={require("../../Images/article2-right-img13.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">LOCHRANZA DISTILLERY</h2>
                    <h4 className="f-lora-i">Isle of Arran</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3 pt-2" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>Ferries arrive on Arran into Brodick, on the east coast, and Lochranza on the north. The latter is right next to the distillery, although requires crossing from Tarbert on the Kintyre Peninsula. Sailings to Brodick depart from Ardrossan, west of Glasgow, so are more practical for many visitors. </h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>Looking out across the water from the northern shores of Arran stands a distillery that makes up in character for what it lacks in heritage. Built only in 1994 - and bringing to an end a period of more than 150 years in which the island had no legal distillation - Lochranza Distillery produces whiskies under the Arran label. With aromas of the sea and pinewoods, their single malts are emblematic of the location itself, a fact which is also true of Lagg Distillery, its sister operation unveiled in 2019 at the southern tip of the island.</p>
                  <p className=" text-justify" variants={textAnimate}>The distillery at Lochranza, however, very much remains the hub of operations. Rain is literally the lifeblood of Scotch whisky, and all the water that goes into the Lochranza bottlings begins its life as fresh rainfall in Loch na Davie, in the hills high above the distillery, from where it flows down to sea level via a series of six waterfalls. Further along the </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>process, the spirit is double-distilled using unpeated malt, then matured in old bourbon and sherry casks. The end results are clean and fresh, with a 10-year-old single malt forming the cornerstone of the range. </p>
                  <p className=" text-justify" variants={textAnimate}>The visitor experience at Lochranza was opened by none other than HM The Queen back in 1997, which was several years too early for her to sample a dram of the 10 year old, although she seems to have blessed the place with good fortune nonetheless. The distillery now draws some 120,000 visitors a year, and in 2018 was named as the Association of Scottish Visitor Attractions' 'Visitor Experience of the Year'. The hard part, if you're here for a tasting, is tearing yourself away. </p>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    Four different tours are on offer here, with the most unusual being the Whisky and Arran Chocolate Pairing.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Goatfell</span>
                    Tackle the island's highest mountain on this popular hike to its 874-metre-high summit. On a fine day, the views are belting.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Brodick Castle</span>
                    The island's best-known attraction is this imposing former hunting lodge, with bags of historical atmosphere and extensive grounds.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">CASKS Café</span>
                    On site at the distillery, this enjoyable café serves home bakes, hot and cold drinks and a good lunch menu. Book ahead.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Mara Fish Bar & Deli</span>
                    From late March to late October you'll find this great seafood joint in Corrie, on the island's east coast. 
                  </p>
                </div>
              </div>
            </div>

            <div className="" ref={eightContainer}>
              <img
                src={require("../../Images/article2-right-img14.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <img
                src={require("../../Images/article2-right-img15.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5 pt-0 pt-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">LINDORES ABBEY</h2>
                    <h4 className="f-lora-i">Fife</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3 pt-2" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>The distillery sits in Newburgh, close to the banks of the Firth of Tay in north Fife. </h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>In 1494, King James IV sent a very specific request to Friar John Cor of Lindores Abbey. The Exchequer Roll of that year records the following order: “To Brother John Cor, 8 bolls of malt, wherewith to make aqua vitae for the King.” Eight bolls of malt would have been enough to make around 400 bottles of whisky, which is evidence enough that the monarch was not only partial to a snifter, but that the whisky grain being produced by the monks was literally fit for a king. </p>
                  <p className=" text-justify" variants={textAnimate}>The abbey, founded on the outskirts of Newburgh in Fife, now lies in ruins, but the name lives on. In 2017, more than half a millennium after the royal request above, the Lindores Abbey distillery was opened by custodians Drew and Helen McKenzie Smith, a glass-fronted temple that manages to be both contemporary and reflective of 500 years of history. The abbey's age-old connections to the drink mean it remains a site of pilgrimage </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>for serious whisky lovers, and the distillery doesn't sell itself short. </p>
                  <p className=" text-justify" variants={textAnimate}>In 2021, its first single malt was released to the public under the name MCDXCIV, the numerals which represent 1494. Drinkers can expect a smooth whisky with everything from dried spices to vanilla playing on the palate. It's matured in a selection of bourbon barrels, wine barriques and sherry butts, which means it's almost certainly even tastier than the batch the king ordered. The latest release, meanwhile, is the lengthily titled Friar John Cor Cask Strength Congregation Batch Chapter 2 - like all Lindores bottlings, it has no added colouring, is non-chill filtered and gets bottled on site.  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    Tours of the facilities are available daily, showing you the inner workings of the distillery.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Scottish Assault Courses</span>
                    Fancy a challenge? This course of almost two miles includes rope swings and barbed-wire army crawl. Not advisable post-whisky…
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Abbey Ruins</span>
                    See the remains of this one-time Tironensian Abbey with your own eyes.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">The Bear Tavern</span>
                    Dating back to the late 18th century, the Bear Tavern remains a great local bar.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Trellis Coffee Shop</span>
                    A popular local spot very much doing things the right way, with breakfast, lunch and home bakes.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-2 mt-sm-5 pt-2" ref={nineContainer}>
              <img
                src={require("../../Images/article2-right-img16.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5 pb-4">
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img17.jpg")}
                  />
                </div>
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img18.jpg")}
                  />
                </div>
              </div>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">BLAIR ATHOL</h2>
                    <h4 className="f-lora-i">Perthshire</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3 pt-2" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>The distillery sits in Pitlochry on the southern fringes of the Cairngorms National Park. The town has its own railway station, with direct links to Perth, Glasgow and Edinburgh. </h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>At the foot of Ben Vrackie, in the Perthshire town of Pitlochry, you'll find a distillery with heritage. It goes by the name of Blair Athol - which is nearly but not quite the same as the nearby village of Blair Atholl, with two Ls - and this isn't the only historical quirk to be found here. The story goes that at the Battle of Culloden in 1746, a soldier named George Robertson hid from Government forces in an ancient oak and was fortified by whisky from nearby Aldour Farm. The farm stood on the site of what is now Blair Athol Distillery, founded in 1798 by Robert Robertson and John Steward. </p>
                  <p className=" text-justify" variants={textAnimate}>It was the famed Victorian whisky blender Arthur Bell, however, who set the distillery rolling on the path to mass-market success. Over the decades, as the whisky made here became one of the key blends in one of the best-selling Scotches in the UK, it became known as the spiritual home of Bell's. And while the Bell's </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>brand isn't necessarily synonymous with refinement or complexity, the Blair Athol single malts that the distillery produces very much are. The 12-year-old bottling is fruity, full and rich. </p>
                  <p className=" text-justify" variants={textAnimate}>As a visitor destination, too, it's fascinating. This is largely because it's one of the oldest working distilleries in the country, with its ivy-clad stone buildings standing as strong and sturdy now as they did 200 years ago. Being situated at the so-called gateway to the Highlands, meanwhile, it draws visitors in big numbers. The ancient Allt Dour - which gave Aldour Farm its name and translates as 'the Burn of the Otter' - still flows through the grounds. </p>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    There are three main options: the Signature Tour, the Allt Dour Tour with six tastings, and the Cask & Cocktail Experience.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Pitlochry Dam Visitor Centre</span>
                    Find out more about everything from hydro-electricity to salmon breeding at this highly-rated visitor centre.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Enchanted Forest</span>
                    Open seasonally, this impressive autumn sound and light show wows evening visitors to the woods near town.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Café Calluna</span>
                    A much-loved place in the centre of town, selling artisan coffee, cakes, sandwiches and more. Becomes a wine bar on weekend evenings.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">The Old Mill Inn</span>
                    Family-owned Old Mill Inn offers 4-star accommodation, lively bistro, daily meals, and ideal location for exploring Highland Perthshire.
                  </p>
                </div>
              </div>
            </div>

            <div className="" ref={tenContainer}>
              <img
                src={require("../../Images/article2-right-img19.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5 pb-4">
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img20.jpg")}
                  />
                </div>
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article2-right-img21.jpg")}
                  />
                </div>
              </div>
              <div className="row mb-4 mb-sm-5 pt-0 pt-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fs-lg fw-regular">THE BORDERS DISTILLERY</h2>
                    <h4 className="f-lora-i">Scottish Borders</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3 pt-2" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>The distillery sits in Hawick, 20 minutes west of Jedburgh and 30 minutes south of Melrose, in the Borders region. </h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>The Scotch whisky trade is full of tales of ambition. Some eight years ago, having raised funds of £10m to help realise its dream, the company behind The Borders Distillery began redeveloping a former industrial block in the town centre of Hawick. Working with what was already there - a former sweet factory, two stone sheds, a brick warehouse and an old office - it set about creating a whisky production unit. When it opened in 2018, it represented the first distillery in the region since 1837. Why Hawick? It had a good supply of fresh water, which already helped the local cashmere and tweed industries, and also had ready access to barley and a strong workforce. All it needed now was the product to match the place. </p>
                  <p className=" text-justify" variants={textAnimate}>Fast forward to today and the distillery has earned accolades by the cask-load, for everything from its architecture to its spirits. The impressive restoration and </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>renovation work makes a visit here worthwhile in its own right, and that's before we even touch on the drink itself. These are still early years for the distillery, meaning its single malts are still maturing, but it offers an award-winning range of vodka, gin and new-make spirit, as well as various blended whiskies.  </p>
                  <p className=" text-justify" variants={textAnimate}>Whisky-lovers also have the chance to invest in one of 1,837 whisky casks (tying in with the year there was last a local distillery), filled on a date of the owner's choosing and stored under bond. The drink's slow maturation process means Scotch whisky and patience go hand in hand, as they always have done. Will the Borders name be cherished by connoisseurs in decades to come? Who knows - but its beginnings have been bright. </p>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    You'll get the lowdown on the awardwinning conversion and restoration project, as well as learning about the distillation process.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Wilton Lodge Park</span>
                    A scenic town park with a tree-lined walk, a waterfall and a four-star Scottish Tourist Board rating.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Hermitage Castle</span>
                    A half-ruined stunner of a castle, initially built in 1240 and now in the care of Historic Scotland.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Denholm Meet</span>
                    Top-notch Italian restaurant/café run by award-winning chef Antonio Caterino, with an antiques and interiors shop upstairs. 
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Adam's Kitchen</span>
                    A great joint serving traditional food and local produce, with a sister restaurant at the local golf club.
                  </p>
                </div>
              </div>
            </div>

            <div className="" ref={elevenContainer}>
              <img
                src={require("../../Images/article2-right-img22.jpg")}
                className={"w-100 mb-4"}
                alt=""
              />
              <div className="row mb-4 mb-sm-5 pt-0 pt-sm-5">
                <div className="col-sm-7">
                  <div
                    className="article2-sec2-top"
                    variants={textAnimate}
                  >
                    <h2 className="fw-regular">GLENMORANGIE</h2>
                    <h4 className="f-lora-i">Ross-shire</h4>
                  </div>
                </div>
                <div className="col-sm-5">
                  <h6 className="fs-sm mt-5 mb-3 pt-2" variants={textAnimate}>GETTING THERE</h6>
                  <h6 className="fw-regular lh-base" variants={textAnimate}>The distillery is on the outskirts of the town of Tain, which has a railway station on the Far North Line, which runs between Inverness and Wick/Thurso. </h6>
                </div>
              </div>
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">

                  <p className=" text-justify" variants={textAnimate}>When husband and wife William and Anne Matheson founded a distillery on a Highland farm in 1843, they could have had little idea how - 180 years later - the Glenmorangie name would have become such a colossus in the whisky world. Today, the copper stills in which it distils its spirit are the tallest in Scotland (reaching giraffe height!) and the whisky itself has been the best-selling single malt in the country for each of the last four decades. It sits way up in Ross-shire, close to the shores of the Dornoch Firth. </p>
                  <p className=" text-justify" variants={textAnimate}>This is a distillery, however, that likes to keep things fresh. It has its own Director of Whisky Creation in the form of biochemist Dr Bill Lumsden, named Master Distiller of the Year on multiple occasions and still pushing things forwards in terms of creativity and invention. Since 2021, he and his team work in an extraordinary new glass still house known as the </p>

                  <p variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className=" text-justify" variants={textAnimate}>Lighthouse, a multi-million-pound, 20-metre-high unit looking out to sea and visible for miles around. </p>
                  <p className=" text-justify" variants={textAnimate}>One notable modern concoction is X by Glenmorangie, a whisky created specifically for mixing - suggested serves, with recipes, include X Sangria and X Peach - but its core range is full of multi-award-winning single malts. These include The Quinta Ruban, a double gold-medalwinning, 14-year-old spirit with a long-lasting silky aftertaste; The Lasanta, a 12-year-old whisky which was distilled to taste like “sipping a sunset” and has a burnished amber glow; and Signet, created using Glenmorangie's chocolate malt spirit, which is made just once a year. If you're looking for something truly collectible, meanwhile, try the Truffle Oak Reserve, of which only 1,000 bottles are in existence. </p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>SEE & DO NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Distillery Tour</span>
                    The distillery has four different tour experiences, including the Set of Four, which includes whiskies hand-picked by Dr Lumsden.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Dornoch Beach</span>
                    A glorious expanse of golden sand on the Dornoch Firth, with Blue Flag accreditation.
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Balblair Distillery</span>
                    Just a few miles away from Glenmorangie you'll find Balblair Distillery, which dates back to 1790.
                  </p>
                </div>
                <div className="col-sm-6">
                  <h6 className=" mb-4" variants={textAnimate}>PLACES TO EAT & DRINK NEARBY </h6>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Surf & Turf</span>
                    This popular spot in nearby Dornoch also has a smaller mobile outlet at Glenmorangie Distillery
                  </p>
                  <p className="fs-sm mb-3" variants={textAnimate}>
                    <span className="fw-semibold d-block mb-3">Greens Restaurant</span>
                    An accomplished local restaurant on the High Street in Tain, using local ingredients where possible.
                  </p>
                </div>
              </div>
            </div>



          </div>

        </div>
      </motion.div>

      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>

    </motion.div>

  );
}

export default Article2;
